const AddFillableFieldsModalEnum = {
  ADD_FILLABLE_FIELDS_MODAL_OPEN: 'ADD_FILLABLE_FIELDS_MODAL_OPEN',
  ADD_FILLABLE_FIELDS_MODAL_CLOSE: 'ADD_FILLABLE_FIELDS_MODAL_CLOSE',
};

export default AddFillableFieldsModalEnum;



// WEBPACK FOOTER //
// ./src-react/Modals/AddFillableFieldsModal/AddFillableFieldsModalConstants.jsx